var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnHint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_hint",
    clipPath: "url(#clip0_44629_207307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape",
    d: "M6.098 2H8.17L7.82 8.552H6.434L6.098 2ZM7.134 11.898C6.80733 11.898 6.53667 11.7953 6.322 11.59C6.10733 11.3753 6 11.114 6 10.806C6 10.498 6.10733 10.2413 6.322 10.036C6.53667 9.83067 6.80733 9.728 7.134 9.728C7.45133 9.728 7.71267 9.83067 7.918 10.036C8.13267 10.2413 8.24 10.498 8.24 10.806C8.24 11.114 8.13267 11.3753 7.918 11.59C7.71267 11.7953 7.45133 11.898 7.134 11.898Z",
    fill: "#2D72FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44629_207307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnHint);
export default __webpack_public_path__ + "static/media/icn_hint.6b5ff97f205d166c4230b24e5e36abaa.svg";
export { ForwardRef as ReactComponent };